<template>
  <CommonPages id="services" classs="services-page" titlePrefix="Services - NONCEBEATS"
    metaDescription="Join NONCEBEATS to connect advertisers and publishers worldwide. Buy and sell premium ad inventory in real time, optimize campaigns, and maximize ROI with transparency and efficiency.">
    <div class="page-header"></div>
    <section class="services-section">
      <div class="services-section__header">
        <h2 class="services-section__title">Our Advertising Solutions</h2>
        <p class="services-section__subtitle">
          We provide cutting-edge ad services designed to help advertisers expand reach, optimize campaigns, and drive measurable ROI.
        </p>
      </div>
      <div class="services-section__grid">
        <div class="service-card" v-for="(service, index) in services" :key="index">
          <img :src="service.image" :alt="service.title" class="service-card__image">
          <div class="service-card__content">
            <h3 class="service-card__title">{{ service.title }}</h3>
            <p class="service-card__description">{{ service.description }}</p>
          </div>
        </div>
      </div>
    </section>
    <section class="how-it-works-section">
      <div class="how-it-works-section__header">
        <h2 class="how-it-works-section__title">How dose it work ?</h2>
      </div>
      <div class="how-it-works-section__grid">
        <div class="work-step" v-for="(step, index) in workSteps" :key="index">
          <div class="work-step__icon-container">
            <img :src="step.icon" :alt="step.title" class="work-step__icon">
          </div>
          <div class="work-step__content">
            <h3 class="work-step__title">{{ step.title }}</h3>
            <p class="work-step__description">{{ step.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue';
import '@/css/services.scss';

export default {
  name: 'Services',
  components: {
    CommonPages,
  },
  data () {
    return {
      services: [
        {
          title: 'High-Quality Ad Placements',
          description: 'Access premium ad spaces across top publishers and trusted digital channels for maximum visibility.',
          image: require('@/assets/service-1.png')
        },
        {
          title: 'Programmatic Bidding',
          description: 'Use intelligent real-time bidding technology to engage your audience at the optimal moment.',
          image: require('@/assets/service-2.png')
        },
        {
          title: 'Performance Optimization',
          description: 'Boost campaign results with continuous data analysis, A/B testing, and precise targeting strategies.',
          image: require('@/assets/service-3.png')
        },
        {
          title: 'Expert Support Team',
          description: 'Receive 24/7 guidance from a dedicated team to ensure smooth campaign execution and actionable insights.',
          image: require('@/assets/service-4.png')
        }
      ],
      workSteps: [
        {
          title: 'Register and Verify',
          description: 'Set up your account and complete the verification process to start trading.',
          icon: require('@/assets/connect-1.svg')
        },
        {
          title: 'Link Ad Platforms',
          description: 'Connect your advertising accounts for smooth, integrated campaign management.',
          icon: require('@/assets/connect-2.svg')
        },
        {
          title: 'Discover Inventory',
          description: 'Browse premium ad spaces across multiple networks and select the best fit for your campaign goals.',
          icon: require('@/assets/connect-3.svg')
        },
        {
          title: 'Bid and Acquire',
          description: 'Engage in real-time bidding to efficiently purchase high-quality ad inventory.',
          icon: require('@/assets/connect-4.svg')
        },
        {
          title: 'Launch and Track',
          description: 'Activate your campaigns and monitor performance using real-time analytics.',
          icon: require('@/assets/connect-5.svg')
        },
        {
          title: 'Optimize and Grow',
          description: 'Leverage insights and expert guidance to continuously enhance and scale your advertising efforts.',
          icon: require('@/assets/connect-6.svg')
        }
      ]
    };
  }
};
</script>
